<template>
  <div class="box-second">
    <p class="title-crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right color3">
        <el-breadcrumb-item>绿色施工</el-breadcrumb-item>
        <el-breadcrumb-item>螺帽监测</el-breadcrumb-item>
      </el-breadcrumb>
    </p>
    <div class="main">
      <div class="main-left">
        <div
          class="main-left-item"
          v-for="(item, index) in towerlist"
          :key="index"
          :class="{ curTower: towerId == item.id }"
          @click="changeTower(item)"
        >
          <p class="name nowrap">{{ item.name }}</p>
          <p class="state color8" v-if="item.online == '离线'">离线</p>
          <p class="state color10" v-else-if="item.online == '在线'">正常</p>
          <p class="state color9" v-else>{{ item.online }}</p>
          <p class="num nowrap">设备编号：{{ item.deviceId }}</p>
        </div>
      </div>
      <div class="main-right">
        <div class="main-right-first">
          <div
            style="
              width: 100%;
              height: 10vh;
              position: relative;
              padding: 0 1vw;
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <span style="font-size: 2vh">实时监测</span>
            <div>
              <span style="font-size: 1.6vh; margin-right: 10px"
                >设备数据时间：{{ allPart.createDate }}</span
              >
              <!-- <el-button type="primary">添加</el-button> -->
            </div>
          </div>
          <div
            style="
              width: 100%;
              height: 20vh;
              position: relative;
              padding: 0 1vw;
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <!--  -->
            <div class="ndata">
              <div class="one_device">
                <div>设备编号：{{allPart.deviceId}}</div>
                <div>设备名称：{{allPart.name}}</div>
                <div>
                  螺母监测点:{{allPart.sums}}个 <span style="margin-right:30px">{{allPart.online}}</span>  
                  <span style="margin-left:30px"> 预警次数：</span>
                  <span style="color:#f00">{{allPart.warningSum}}</span>
                </div>
              </div>
              <div style="position: relative">
                <img class="blue" style="width:120px;height:120px;" src="../../../assets/image/white.png" alt />
                <img class="round round_normal" style="width:120px;height:120px;" src="../../../assets/image/round.png" alt/>

                <div
                  style="
                    position: absolute;
                    top: 38px;
                    left: 22px;
                    color: #6b6b6b;
                  "
                >
                  <!-- <div v-if="item.connectedStatus=='离线'">{{item.connectedStatus}}</div> -->
                  <div>监测时长</div>
                  <div>{{allPart.time||0}}天</div>
                </div>
              </div>
              <div>
                  <el-button type="warning" @click="handleEdit(allPart)">编辑</el-button>
                  <el-button type="info" @click="unBind(allPart)">解绑</el-button> 
              </div>
            </div>
          </div>
          <div style="width:100%;height"></div>
        </div>
        <!-- 特种设备操作人员列表 .real-data-->
        <div
          class="main-right-first"
          style="margin-top: 1vh; height: calc(100% - 31vh); padding: 1vh"
        >
          <p
            style="
              text-align: left;
              padding: 0 1vh;
              font-size: 1vw;
              height: 3vh;
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <!-- <span>特种设备操作人员列表</span> -->
            <el-date-picker
              v-model="tableTime"
              value-format="yyyy-MM"
              type="month"
              @change="doFilter"
              placeholder="选择日期"
            >
            </el-date-picker>
          </p>
          <div class="special-table">
            <el-table
              :data="tableData"
              height="calc( 100% - 5vh )"
              style="width: 100%"
            >
              <el-table-column prop="connectDate" label="监测时间"> </el-table-column>
              <el-table-column prop="name" label="监测点">
              </el-table-column>
              <el-table-column prop="nutHostId" label="设备号"> </el-table-column>
              
            </el-table>
            <!-- 分页展示 -->
            <!-- <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination> -->
          </div>
          <el-dialog
                    :title="dialogTitle"
                    :visible.sync="addFormVisible"
                    center
                    :append-to-body="true"
                    :lock-scroll="false"
                    class="add-form"
                    width="30%"
                >
                    <el-form
                    :model="addForm"
                    ref="addForm"
                    label-width="160px"
                    :label-position="labelPosition"
                    :rules="rules"
                    >
                    <el-form-item label="设备名称：">
                        <el-input v-model="addForm.name" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="设备序列号：" prop="deviceId">
                        <el-input v-model="addForm.deviceId" placeholder="请输入" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="主机使用设备项：" prop="nutUseType">
                        <el-select v-model="addForm.nutUseType">
                        <el-option
                            v-for="item in typeNameAll"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="厂家：">
                        <el-select v-model="addForm.machType">
                        <el-option
                            v-for="item in millNameAll"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="位置:">
                        <el-input type="textarea" v-model="addForm.locationDesc"></el-input>
                    </el-form-item> -->
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                    <el-button @click="addFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                    </div>
                </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HighCharts from 'highcharts'
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
  data() {
    return {
      groupId: '',
      towerId: '', //当前卸料id
      deviceId: '', //当前卸料deviceId
      towerlist: [], //卸料设备列表
      allPart: {}, //当前卸料信息
      towerH: {}, //24小时数据
      tableData: [], //特种人员列表
      // websock: null,
      // timeRefrsh:null,
      showUrl: '',
      cameraData: {}, //监控摄像头信息
      tableTime: util.myTime.getCurMonth(),
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      addForm: [], // 添加设备表单数组
      addFormVisible: false, // 弹出框是否显示
       dialogTitle: '', //弹出框标题
      labelPosition: 'right', // 添加设备弹出框position属性
       rules: {
        deviceId: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        nutUseType: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
      },
      typeNameAll:[]
    }
  },
  mounted() {
    this.groupId = util.session.get('groupId')
    this.getTowerList()
    // this.setChart1()
  },
  created() {
    //页面刚进入时开启长连接
  },
  destroyed: function () {
    //页面销毁时关闭长连接
    //this.websocketclose();
    // if(this.timeRefrsh){
    //     window.clearTimeout(this.timeRefrsh)
    // }
  },
  methods: {
    //获取塔吊设备
    getTowerList() {
      var that = this
      myHttp
        .selectNutHostList({
          projectId: this.groupId,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            console.log(resp)
            var list = resp.data.data.List || []
            that.towerlist = list
            if (list.length > 0 && that.towerId == '') {
              that.towerId = list[0].id
              that.deviceId = list[0].deviceId
              // that.initWebSocket()
            }
            if (that.towerId != '') {
              that.getRealInfo()
              // that.getHour()
              that.getPerson() //获取操作记录
            }
          }
        })
    },
    getRealInfo() {
      var that = this
      myHttp
        .selectNutHost({
          id: this.towerId,
          v: new Date().getTime(),
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            
            var data = resp.data.data.NutHost || {}
            data.time =util.myTime.getdayByDate(util.myTime.getCurTime,data.createDate)
            var now = Date.now()
             that.allPart = data
              console.log( that.allPart)
            // that.setChart1()
          }
          // that.timeRefrsh = setTimeout(function(){
          //     that.getRealInfo()
          // },60000)
        })
    },
    //获取监控视频
    // getVideo(serial,channel){
    //     var that = this
    //     myHttp.getYsToken().then(function(resp){
    //         if(resp.data.code=='200'){
    //             var ysToken = resp.data.data.accessToken||''
    //             that.showUrl = '/monitor/view/one.html?serial='+serial+'&channel='+channel+'&token='+ysToken
    //         }
    //     })
    // },
    //获取24小时监测数据
    // getHour(){
    //     var that = this
    //     myHttp.get24HourByTower({
    //         projectId:this.groupId,
    //         deviceId:this.deviceId
    //     }).then(function(resp){
    //         if(resp.data.code=='200'){
    //             var data = resp.data.data.tdTime
    //             that.towerH = data
    //             that.setChart1(data)
    //         }
    //     })
    // },
    //偏置值
    setChart1() {
      // 偏置值
      var bias = this.allPart.bias || 0
      var echart1 = this.$echarts.init(document.getElementById('echart1'))
      echart1.setOption({
        tooltip: {
          formatter: '{a} <br/>{b} : {c}%',
        },
        series: [
          {
            name: '偏置值',
            type: 'gauge',
            min: -100,
            max: 100,
            radius: '80%',
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [
                  [0.8, '#ACBBFA'],
                  [1, '#617AE5'],
                ],
                width: 10,
                shadowColor: '#fff', //默认透明
                shadowBlur: 10,
              },
            },
            splitLine: {
              // 分隔线
              length: 15, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                width: 3,
                color: '#9198B2',
              },
            },
            detail: { formatter: '{value}', fontSize: 20 },
            data: [{ value: bias, name: '偏置值' }],
          },
        ],
      })
      var weight = this.allPart.weight || 0 //当前重量
      // 预警重量\
      var earlyWarningWeight = this.allPart.earlyWarningWeight || 1000
      var echart2 = this.$echarts.init(document.getElementById('echart2'))
      echart2.setOption({
        tooltip: {
          formatter: '{a} <br/>{b} : {c}%',
        },
        series: [
          {
            name: '偏置值',
            type: 'gauge',
            min: 0,
            max: earlyWarningWeight,
            radius: '80%',
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [
                  [0.8, '#ACBBFA'],
                  [1, '#617AE5'],
                ],
                width: 10,
                shadowColor: '#fff', //默认透明
                shadowBlur: 10,
              },
            },
            splitLine: {
              // 分隔线
              length: 15, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                width: 3,
                color: '#9198B2',
              },
            },
            detail: { formatter: '{value}吨', fontSize: 20 },
            data: [{ value: weight, name: '' }],
          },
        ],
      })
      // 报警重量
      var alarmWeight = this.allPart.alarmWeight || 1000
      var echart3 = this.$echarts.init(document.getElementById('echart3'))
      echart3.setOption({
        tooltip: {
          formatter: '{a} <br/>{b} : {c}%',
        },
        series: [
          {
            name: '偏置值',
            type: 'gauge',
            min: 0,
            max: alarmWeight,
            radius: '80%',
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [
                  [0.8, '#ACBBFA'],
                  [1, '#617AE5'],
                ],
                width: 10,
                shadowColor: '#fff', //默认透明
                shadowBlur: 10,
              },
            },
            splitLine: {
              // 分隔线
              length: 15, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                width: 3,
                color: '#9198B2',
              },
            },
            detail: { formatter: '{value}吨', fontSize: 20 },
            data: [{ value: weight, name: '' }],
          },
        ],
      })
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getPerson()
    },
    //根据主机id 查询所有的预警数据
    getPerson() {
      var that = this
      myHttp
        .selectNutRecordWaring({
          hostId: this.towerId,
          projectId: this.groupId,
          date: this.tableTime,

        })
        .then(function (resp) {
          if (resp.data.code == '200') {
              console.log(resp)
            var list = resp.data.data.NutRecord|| []
            for (var i = 0; i < list.length; i++) {
              list[i].index =
                that.pageSize * (parseInt(that.currentPage) - 1) + (i + 1)
            }
            that.tableData = list
            // that.totalItems = resp.data.data.NutRecord.total
            if (that.tableData.length == 0) {
              that.dataText = '暂无数据'
            }
          }
        })
    },
    //获取班组id
    getTeamId(id) {
      var list = this.towerlist
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (id == list[i].deviceId) {
          result = list[i].teamsId
        }
      }
      return result
    },
    //获取sn
    getSn(id) {
      var list = this.towerlist
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (id == list[i].deviceId) {
          result = list[i].attendanceSn
        }
      }
      return result
    },

    //选择塔吊
    changeTower(obj) {
      this.towerId = obj.id
      this.deviceId = obj.deviceId
      // window.clearTimeout(this.timeRefrsh)
      this.getRealInfo()
      // this.getHour()
      this.getPerson()
      // this.websocket.close();
      // this.initWebSocket()
    },

    //跳转查看信息
    attendInfo(row) {
      this.$router.push({
        name: 'specialPerson',
        params: { id: this.towerId, personId: row.personId, status: '1' },
      })
    },

    //跳转监控信息页面
    toDetail(id, channel) {
      this.$router.push({ path: '/monitCtl/' + id + '/' + channel })
    },

    //
    doFilter() {
      this.currentPage = 1
      this.getPerson()
    },
    // 编辑数据
    handleEdit(row) {
        console.log(row) 
      this.dialogTitle = '编辑设备信息'
      this.addFormVisible = true
      this.addForm= row
    }, 
        // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
            //修改 1111
            delete that.addForm.createDate
            delete that.addForm.updateDate
            that.addForm.projectId = that.groupId
            that.addForm.updateBy = util.session.get("user").id
            myHttp.updateNutHost(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.addFormVisible = false
                  that.getTowerList()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
        //   }
        }
      })
    },
     //解绑
    unBind(row){
      var that = this
      this.$confirm('此操作将解绑所有的螺母, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.unbundlingNut({
            id: row.id,
        }).then(function(resp) {
          if (resp.data.code == '200') {
            that.$message.success('解绑成功')
            that.getTowerList()
            this.getRealInfo()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      })
    },
    // 跳转预警监测页面
    // deatilWarn(){
    //     var id = this.deviceId
    //     this.$router.push({path:'/perWarn/'+id})
    // },
    //initWebSocket长连接
    // initWebSocket(){
    //     if(this.websock){
    //         this.websock.close();
    //     }
    //     var that = this
    //     //初始化weosocket
    //     if('WebSocket' in window){
    //         var url="ws://47.103.123.116:17001/equipwebsocket/"+this.deviceId;//ws地址;
    //         this.websocket = new WebSocket(url);
    //     }
    //     else{
    //         alert('Not support websocket')
    //     }
    //     //连接发生错误的回调方法
    //     this.websocket.onerror = function(){
    //         //setMessageInnerHTML("error");
    //     };
    //     //连接成功建立的回调方法
    //     this.websocket.onopen = function(event){
    //         //$("#serverinfo").hide();
    //         that.errorFlag = false
    //         that.timeOutObj=null;
    //     }
    //     //接收到消息的回调方法
    //     this.websocket.onmessage = function(event){
    //         if(event.data=="连接成功")return;
    //         var x=JSON.parse(event.data);
    //         if(x.tower.deviceId==that.deviceId){
    //             var data = x.tower
    //             data.angle = data.angle && ''!=data.angle?data.angle:0
    //             that.allPart = data
    //         }
    //     }
    //     //连接关闭的回调方法
    //     this.websocket.onclose = function(){
    //         this.timeOutObj=setTimeout(function(){
    //             that.initWebSocket();
    //         }, 60000);
    //         // $("#serverinfo").show();
    //         that.errorFlag = true
    //     }
    //     //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
    //     window.onbeforeunload = function(){
    //         that.websocket.close();
    //     }
    // },
  },
}
</script>
<style scoped>
@import '../../../assets/css/clock.css';
.main-left {
  width: 10vw;
  height: 100%;
  position: relative;
  padding: 1vh 0.6vh;
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  background: #fff;
  align-content: flex-start;
}
.main-left-item {
  height: 7vh;
  width: 100%;
  position: relative;
  background: #e7f1fb;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  align-items: center;
  padding: 0.5vh;
  cursor: pointer;
  margin-top: 1vh;
}
.main-left-item p {
  height: 3vh;
  position: relative;
  text-align: left;
  display: flex;
  align-content: center;
  align-items: center;
}
.main-left-item .name {
  width: calc(100% - 3vw);
  position: relative;
}
.main-left-item .state {
  width: 3vw;
  position: relative;
  justify-content: flex-end;
}
.main-left-item .num {
  width: 100%;
  position: relative;
}
.curTower {
  background: #e9f1fa;
}
.curTower .name,
.curTower ,
.curTower .num {
  color: #000;
}

.main-right {
  width: calc(100% - 10vw);
  height: 100%;
  position: relative;
  padding: 0 1vh;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  overflow: auto;
}
.main-right-first {
  width: 100%;
  height: 30vh;
  position: relative;
  border-radius: 6px;
  background: #fff;
  /* display: flex; */
  flex-wrap: wrap;
  min-height: 260px;
}
.real-data {
  width: 33%;
  height: 100%;
  position: relative;
  padding: 1vh;
  display: flex;
  flex-wrap: wrap;
}
.real-data-l,
.real-data-r {
  width: 50%;
  height: calc(100% - 3vh);
  padding: 2vh 0;
}
.real-data-l-item {
  width: 100%;
  display: flex;
  height: 6vh;
  align-items: flex-end;
  margin-bottom: 1vh;
}
.real-data-l-item span {
  display: inline-block;
  /* width: 10vw; */
  margin-left: 0.8vw;
  height: 4vh;
  display: flex;
  align-content: center;
  align-items: center;
}
.real-data-l-item .abr {
  position: absolute;
  bottom: 2vh;
  left: 60%;
  width: 3.5vw;
  height: 3vh;
  /* line-height: 25px; */
  font-size: 0.8vw;
  text-align: center;
  color: #707070;
  background: #c5c1c1;
  background: url(../../../assets/image/box.png) no-repeat;
  background-size: 100% 100%;
}
.real-clock {
  width: 33%;
  height: 100%;
  position: relative;
  padding: 1vh;
}
#wrap.real-clock-con {
  /* width:100%;
        height:calc( 100% - 3vh ); */
  /* padding:2vh 0; */
  margin-top: 3vh;
  width: 220px;
  height: 220px;
}
.main-dure {
  width: 70%;
  height: 100%;
  position: relative;
  padding-left: 2vw;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  align-items: center;
  justify-content: center;
  justify-items: center;
}
.main-dure p {
  width: 100%;
  position: relative;
  height: 4vh;
  display: flex;
}
.main-dure p span {
  width: 16.6%;
  position: relative;
}
.special-table {
  width: 100%;
  height: calc(100% - 3vh);
  position: relative;
  padding: 1vh;
}
.no-photo {
  width: 6vh;
  height: 6vh;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-content: center;
  background: #f5f7fa;
  flex-wrap: wrap;
  color: #c0c4cc;
}
.item-info {
  width: 100%;
  height: 5vh;
  position: relative;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: space-around;
  background: #e7f1fb;
}
.item-info .name {
  flex: 1;
  text-align: center;
}
.item-info img {
  width: 1.5vw;
  height: auto;
  position: relative;
  margin: 0 1vw;
}
.ndata {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.one_device {
  text-align: left;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.round {
  display: block;
  position: absolute;
  display: block;
  top:0;
}
.round_normal {
  animation: rotate 6s linear infinite;
}
.color10{
    color: #84caa0;
}
.color8{
    color: #f56c6d;
}
@keyframes rotate {
  0% {
    transform: rotateZ(0deg); /*从0度开始*/
  }
  100% {
    transform: rotateZ(360deg); /*360度结束*/
  }
}
</style>
<style>
.real-data .el-progress-bar__outer {
  background: #69bcff;
}
@import '../../../assets/css/common.css';
</style>